module.exports = __webpack_public_path__ + "static/media/14.M-Cure 1-c.797aad6f.jpg";